import { Typography } from '@mui/material';
import { EMPTY_VALUE } from 'shared/constants';
import { Currencies } from 'shared/types';
import { formatCurrency } from 'shared/utils';
import BudgetTypography from '../components/BudgetTypography/BudgetTypography';
import { formatNumberWithSpaces } from '../../../../../../../common/BudgetTable/utils/formatNumberWithSpaces';

export const renderBudgetCell = (
  value: number | null,
  rowColor: string,
  currency: Currencies,
  exchangeRate?: number
): JSX.Element | string => {
  const budget = formatNumberWithSpaces(value?.toFixed(0));

  const exchangedBudget =
    exchangeRate && value
      ? formatCurrency(Math.round(value / exchangeRate), 'EUR')
      : null;
  return (
    <>
      <BudgetTypography color={rowColor} value={budget} align="right" />
      {currency !== 'PLN' && (
        <Typography
          color={rowColor}
          fontWeight={700}
          fontSize="0.7rem"
          textTransform="uppercase"
          letterSpacing={0.04}
          textAlign="left"
        >
          {exchangedBudget ? `(${exchangedBudget})` : EMPTY_VALUE}
        </Typography>
      )}
    </>
  );
};
